export default "__VITE_ASSET__9FdacgUu__"